import servise from '@/router/axios'

// 分页查询渠道 RTA 服务列表
export const getChannelRtaPage = (params) => {
  return servise({
    url: '/ocpx/channel-rta/page',
    method: 'get',
    params
  })
}

// 根据 ID 查询渠道 RTA 服务详情
export const getChannelRtaById = (id) => {
  return servise({
    url: `/ocpx/channel-rta/${id}`,
    method: 'get'
  })
}

// 新增渠道 RTA 服务
export const addChannelRta = (data) => {
  return servise({
    url: '/ocpx/channel-rta',
    method: 'post',
    data
  })
}

// 更新渠道 RTA 服务
export const updateChannelRta = (data) => {
  return servise({
    url: '/ocpx/channel-rta',
    method: 'put',
    data
  })
}

// 删除渠道 RTA 服务
export const deleteChannelRta = (id) => {
  return servise({
    url: `/ocpx/channel-rta/${id}`,
    method: 'delete'
  })
}

// 更新渠道 RTA 服务状态
export const updateChannelRtaStatus = (id, status) => {
  return servise({
    url: `/ocpx/channel-rta/${id}/status/${status}`,
    method: 'put'
  })
}

// 查询所有启用的渠道 RTA 服务
export const getEnabledChannelRtaList = () => {
  return servise({
    url: '/ocpx/channel-rta/enabled/list',
    method: 'get'
  })
}

// 查询所有渠道 RTA 服务列表（不分页）
export const getChannelRtaList = () => {
  return servise({
    url: '/ocpx/channel-rta/list',
    method: 'get'
  })
}
